import { SystemToast } from "@/types/system";

const PUBLIC_SYSTEM_TOAST_URL =
  "https://storage.googleapis.com/decoda-public/system-toasts/toasts.json";

interface PublicSystemToast extends Omit<SystemToast, "id"> {
  id: string | number;
  tenantSubdomains?: string[];
  startsAt: string;
  expiresAt: string;
}

export async function fetchSystemToasts(
  tenantSubdomain?: string,
): Promise<SystemToast[] | null> {
  if (!tenantSubdomain) return null;

  try {
    const response = await fetch(PUBLIC_SYSTEM_TOAST_URL);
    if (!response.ok) {
      throw new Error(`System toast catalog returned ${response.status}`);
    }

    const now = Date.now();
    const toasts = (await response.json()) as PublicSystemToast[];
    return toasts
      .filter((toast) => {
        const startsAt = Date.parse(toast.startsAt);
        const expiresAt = Date.parse(toast.expiresAt);
        const tenantMatches =
          !toast.tenantSubdomains?.length ||
          toast.tenantSubdomains.includes(tenantSubdomain);
        return startsAt <= now && expiresAt >= now && tenantMatches;
      })
      .map((toast) => ({
        ...toast,
        id: String(toast.id),
      }));
  } catch (error) {
    console.error(
      "Error fetching system toasts from the public catalog:",
      error,
    );
    return null;
  }
}
